import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import './plugins/axios'
import VueSweetalert2 from "vue-sweetalert2";
import 'sweetalert2/dist/sweetalert2.min.css';
import router from './router'
import i18n from "../src/lang/lang";
import store from './store/store'
import movable from './statics/movableDialog';

Vue.config.productionTip = false

Vue.use(VueSweetalert2)
Vue.use(movable);

new Vue({
  vuetify,
  router,
  i18n,
  store: store,
  render: h => h(App)
}).$mount('#app')
